import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SelectedPartnerService } from '../selected-partner.service';
import { AppFailureComponent } from './failure/app-failure.component';
import { AppInsufficientPermissionComponent } from './insufficient-permission/app-insufficient-permission.component';
import { EntryComponent } from './entry/entry.component';
import { LogoutComponent } from './logout/logout.component';
import { OAuth2Service } from '@vendasta/oauth2';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [OAuth2Service],
  },
  {
    path: 'app-failure',
    component: AppFailureComponent,
  },
  {
    path: 'app-failure/:message',
    component: AppFailureComponent,
  },
  {
    path: 'app-failure/:message/:backLink',
    component: AppFailureComponent,
  },
  {
    path: 'app-insufficient-permission/:partnerId',
    component: AppInsufficientPermissionComponent,
  },
  { path: 'logout', component: LogoutComponent },
  {
    path: 'entry/:partnerId',
    component: EntryComponent,
    resolve: { partnerId: SelectedPartnerService },
  },
  {
    path: 'ms-wordfence-report',
    loadChildren: () =>
      import('./ms-wordfence-report/ms-wordfence-report.module').then((m) => m.MSWordfenceReportModule),
    canActivate: [OAuth2Service],
  },
  {
    path: 'partner/:partnerId',
    resolve: { partnerId: SelectedPartnerService },
    canActivateChild: [OAuth2Service],
    children: [
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings-page.module').then((m) => m.SettingsPageModule),
      },
      {
        path: 'templates',
        loadChildren: () => import('./templates/templates-page.module').then((m) => m.TemplatesPageModule),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./partner-admin-dashboard/partner-admin.module').then((m) => m.PartnerAdminModule),
      },
      {
        path: 'uptime',
        loadChildren: () => import('./uptime-report/uptime-report.module').then((m) => m.UptimeReportModule),
      },
      // {
      //   path: 'vulnerabilities',
      //   loadChildren: () =>
      //     import('./partner-vulnerability-table/partner-vulnerability-table.module').then(
      //       (m) => m.PartnerVulnerabilityTableModule,
      //     ),
      // },
    ],
  },
];
